module.exports = __webpack_public_path__ + "img/team_leader_3.bb6e007b.png";